import React from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { Message } from 'primereact/message';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { useWarrantyDateChangeApprovalData } from './hook/useWarrantyDateChangeApprovalData';
import WarrantyDateChangeApprovalFilters from './components/WarrantyDateChangeApprovalFilters';
import WarrantyDateChangeApprovalTable from './components/WarrantyDateChangeApprovalTable';
import RejectReasonDialog from './components/RejectReasonDialog';
import { DATE_CHANGE_STATUS } from '../../../../utils/formDateChangeConstants';

const TAB_STATUS_MAP = {
    0: DATE_CHANGE_STATUS.SENT_FOR_APPROVAL,
    1: DATE_CHANGE_STATUS.RETURN,
    2: DATE_CHANGE_STATUS.APPROVED
};

const WarrantyDateChangeApproval = () => {
    const { th } = useLanguage();
    const {
        canRequestDateChange,
        canApproveDateChange,
        activeTabIndex,
        handleTabChange,
        formTypeFilter,
        handleFormTypeChange,
        filterFields,
        handleApplyFilters,
        handleResetFilters,
        lazyParams,
        onPage,
        items,
        totalRecords,
        tabCounts,
        loading,
        handleApprove,
        approvingRowId,
        openRejectDialog,
        closeRejectDialog,
        handleReject,
        isRejecting,
        rejectDialogRequest
    } = useWarrantyDateChangeApprovalData();

    const tabLabels = [
        { label: th('formDateChangeRequest.tabs.pending'), icon: 'pi pi-clock', color: 'blue' },
        { label: th('formDateChangeRequest.tabs.returned'), icon: 'pi pi-replay', color: 'red' },
        { label: th('formDateChangeRequest.tabs.approved'), icon: 'pi pi-check-circle', color: 'green' }
    ];

    if (!canRequestDateChange) {
        return (
            <div className="card">
                <Message severity="warn" text={th('common.noPermission')} className="w-full" />
            </div>
        );
    }

    return (
        <div className="card">
            <div className="page-header mb-4">
                <h1 className="page-title mb-2">{th('formDateChangeRequest.title')}</h1>
            </div>

            <WarrantyDateChangeApprovalFilters formTypeFilter={formTypeFilter} onFormTypeChange={handleFormTypeChange} filterFields={filterFields} onApplyFilters={handleApplyFilters} onResetFilters={handleResetFilters} />

            <TabView activeIndex={activeTabIndex} onTabChange={(e) => handleTabChange(e.index)}>
                {tabLabels.map((tab, index) => (
                    <TabPanel
                        key={index}
                        header={
                            <span className="tab-header">
                                <i className={`${tab.icon} mr-2`}></i>
                                {tab.label}
                                {tabCounts[TAB_STATUS_MAP[index]] > 0 && <span className={`ml-2 px-2 py-1 border-round text-xs font-semibold bg-${tab.color}-100 text-${tab.color}-800`}>{tabCounts[TAB_STATUS_MAP[index]]}</span>}
                            </span>
                        }
                    >
                        <WarrantyDateChangeApprovalTable
                            items={items}
                            lazyParams={lazyParams}
                            totalRecords={totalRecords}
                            loading={loading}
                            onPage={onPage}
                            currentStatus={TAB_STATUS_MAP[index]}
                            canApproveDateChange={canApproveDateChange}
                            onApprove={handleApprove}
                            approvingId={approvingRowId}
                            onReject={openRejectDialog}
                        />
                    </TabPanel>
                ))}
            </TabView>

            <RejectReasonDialog visible={!!rejectDialogRequest} request={rejectDialogRequest} onHide={closeRejectDialog} onConfirm={handleReject} isSubmitting={isRejecting} />
        </div>
    );
};

export default WarrantyDateChangeApproval;
